/* eslint-disable class-methods-use-this */
/**
 * Count To
 */

class CountTo {
  constructor() {
    function counterInit() {
      $('.count').each(function() {

        const scrollPos = window.pageYOffset;
        // alert(scrollPos);
        var counter = $('#counter').offset().top;
        var counter = counter -550;

        var $this = $(this),
            countTo = $this.attr('data-count');

        if (scrollPos > counter) {
          $({ countNum: $this.text()}).animate({
            countNum: countTo
          },

          {
            duration: 2000,
            easing:'linear',
            step: function() {
              $this.text('+' + Math.floor(this.countNum));
            },
            complete: function() {
              $this.text('+' + this.countNum);
              //alert('finished');
            }

          });
        }

      });

    }

    counterInit();

    $(window).scroll(counterInit);
  }
}

export default CountTo;

